import React from 'react';
import Isvg from 'react-inlinesvg';
import history from './../history';

class Header extends React.Component {
    constructor() {
        super();
        this.renderLogos = this.renderLogos.bind(this);
    }

    renderLogos() {
        const { lang: activeLang, languages } = this.props;

        const icons = languages.map(lang => {
            const isActive = lang === activeLang;
            const classes = [`logo-${lang}`];
            if (isActive) {
                classes.push('is-active');
            }
            return (
                <Isvg src={`/svg/schneider-logo-${lang}.svg`} className={classes.join(' ')} key={lang} />
            );
        });

        return <div className={`logo-container`}>{icons}</div>;
    }

    render() {
        const { lang, dealer, texts } = this.props;
        const logoClass = dealer ? "dealer-logo-mobile" : "";
        const classes = ['main-header'];
        if (dealer) {
            classes.push('main-header--dealer');
        }

        return (
            <header className={classes.join(' ')}>
                {!this.props.isLoading && (
                    <div className="left" title={texts['header.icon.back']}>
                        <div onClick={history.goBack} className="icon back">
                            <Isvg src="/svg/arrow-left-mobile.svg" />
                        </div>
                        {dealer ? (
                            <div className="dealer-logo">
                                <img src={dealer.logo} alt={dealer.name} />
                            </div>
                        ) : null}
                    </div>
                )}

                <div className={`center ${logoClass}`}>
                    <div onClick={() => history.push(`/${lang}`)} className="icon logo">
                        {this.renderLogos()}
                        <Isvg src={`/svg/schneider-logo-compact.svg`} className="is-compact" />
                    </div>
                </div>

                {!this.props.isLoading && (
                    <div className="right utility">
                        <div
                            className="icon toggle-language-menu"
                            onClick={this.props.toggleLanguageMenu}
                            title={texts['header.icon.language']}
                        >
                            <Isvg src="/svg/globe.svg" />
                        </div>
                        <div
                            className="icon toggle-site-menu"
                            onClick={this.props.sideMenuToggle}
                            title={texts['header.icon.menu']}
                        >
                            <Isvg src="/svg/menu-mobile.svg" />
                        </div>
                    </div>
                )}
            </header>
        );
    }
}

export default Header;
